import React, { useContext, useEffect, useState } from "react";
import GeofenceHead from "./GeofenceHead/GeofenceHead";
import GeofenceBody from "./GeofenceBody/GeofenceBody";
import GeofenceFooter from "./GeofenceFooter/GeofenceFooter";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
	useAddGeofencesMutation,
	useEditGeofencesMutation,
} from "../../../Redux/service/Geofences/Geofences";
import { useDispatch, useSelector } from "react-redux";
import { popupcontext } from "../../../context/Popupscontext";
import {
	addGeofence,
	editGeofence,
} from "../../../Redux/service/Geofences/GeofenceSlice";
import { toast } from "react-toastify";
import { useMap } from "react-leaflet";
import trans, { isRTL } from "../../../utils";
import { SpeedInputValue, SpeedValue } from "../../../JsHelpers/PlatformUnits";

export default function GeofenceForm({ area, Editvalues }) {
	const [submitAttempt, setSubmitAttempt] = useState(false);
	const [addGeofences, { isLoading }] = useAddGeofencesMutation();
	const [editGeofences] = useEditGeofencesMutation();
	const dispatch = useDispatch();
	const inf = useSelector((state) => state.users.user);
	const map = useMap();

	let { handleClose, isEditing, setEdited, setRefetchGeofences } =
		useContext(popupcontext);

	const handleAddGeo = async (val) => {
		try {
			const addedGeofence = await addGeofences(val)
				.unwrap()
				.catch((err) => err);
			map.dragging.enable();
			map.scrollWheelZoom.enable();

			toast.success(trans("New Geofence Is Added"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			dispatch(addGeofence(addedGeofence));
			handleClose("editing");
			setRefetchGeofences(true);
		} catch (error) {
			toast.error(trans("Failed to add geofence"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	const handleEditGeo = async (val) => {
		try {
			const editedGeofence = await editGeofences({
				id: Editvalues.id,
				val: val,
			})
				.unwrap()
				.catch((err) => err);
			toast.success(trans("Geofence Is Edited Successfully"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			setEdited(true);
			map.dragging.enable();
			map.scrollWheelZoom.enable();
			handleClose("editing");
			setRefetchGeofences(true);
			dispatch(editGeofence(editedGeofence));
		} catch (error) {
			toast.error(trans("Failed to edit geofence"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};

	let validSchema = Yup.object({
		name: Yup.string().required(trans("Name is required")),
		attributes: Yup.object({
			color: Yup.string().required(trans("Geofence status is required")),
			speedLimit: Yup.number()
				.min(1, trans("Speed limit can't be less than 1"))
				.typeError(trans("Speed Limit must be a number"))
				.nullable(),
		}),
	});

	const formik = useFormik({
		initialValues: {
			name: "",
			description: "",
			attributes: {
				color: null,
				speedLimit: null,
			},
			area: area,
		},
		validationSchema: validSchema,
		onSubmit: async (val) => {
			setSubmitAttempt(true);

			// Wrap speedLimit with speedInputValue
			const updatedVal = {
				...val,
				attributes: {
					...val.attributes,
					speedLimit: SpeedInputValue(
						val.attributes?.speedLimit,
						inf.attributes?.speedUnit || "kn"
					),
				},
			};

			if (!isEditing) {
				handleAddGeo(updatedVal);
			} else {
				handleEditGeo(updatedVal);
			}
		},
	});
	useEffect(() => {
		if (isEditing && Editvalues) {
			const updatedValues = {
				...Editvalues,
				attributes: {
					...Editvalues.attributes,
					speedLimit: SpeedValue(
						Editvalues.attributes?.speedLimit,
						inf.attributes?.speedUnit || "kn"
					),
				},
			};

			formik.setValues(updatedValues);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [Editvalues, inf.attributes?.speedUnit]);

	const handleSubmit = (e) => {
		setSubmitAttempt(true);
		formik.handleSubmit(e);
	};
	const lang = localStorage.getItem("lang") || "en";

	return (
		<form onSubmit={handleSubmit} dir={!isRTL ? "ltr" : "rtl"}>
			<div
				className={`Geofence-Form ${
					lang === "en" ? "Geofence-Form-ltr" : "Geofence-Form-rtl"
				}`}
			>
				<GeofenceHead />
				<div className="H-line"></div>
				<GeofenceBody AddGeo={formik} />
				<div className="H-line"></div>
				<GeofenceFooter
					AddGeo={formik}
					submitAttempt={submitAttempt}
					isLoading={isLoading}
				/>
			</div>
		</form>
	);
}
